import React, { useState } from "react";
import { TextField, Card, CardContent, Box, Typography } from "@mui/material";
import SriyanshCardHeader from "../../components/CardHeader";
import { useNavigate } from "react-router-dom";
import { BoxStyle } from "../../constantVaribles/constatanvariable";
import TokenService from "../../service/TokenService";
import EncryptService from "../../service/EncryptionService";
import apiClient from "../../BaseUrl/apiClient.js";
import useToast from "../../customHook/useToast";
import { IconButton, InputAdornment } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
const ChangePasswordForm = () => {
  const tokenServiceDetails = TokenService.getUserDetails();
  const logineuname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  //const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});

  const { showToast, Toast } = useToast();

  const navigate = useNavigate();

  const handleClose = () => {
    navigate(-1);
  };

  const validate = () => {
    const errors = {};
    // if (!currentPassword) errors.currentPassword = 'Current password is required';
    if (!newPassword) errors.newPassword = "New password is required";
    if (newPassword !== confirmPassword)
      errors.confirmPassword = "Passwords do not match";
    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length === 0) {
      // Handle password change logic here

      apiClient
        .post("/changepassword", {
          uname: logineuname,
          pastext: confirmPassword,
          ipp: ip,
        })
        .then(function (response) {
          showToast("Your password is changed");
        })
        .catch(function (error) {
          setErrors(error.data);
        });

      // Clear form fields
      // setCurrentPassword('');

      setNewPassword("");
      setConfirmPassword("");
    } else {
      setErrors(validationErrors);
    }
  };

 return (
  <Box
    sx={{
      width: "100%",
      maxWidth: "100%",
      minWidth: 0,
      boxSizing: "border-box",
      overflowX: "hidden",
      p: { xs: 1, sm: 1.5, md: 2 },
    }}
  >
    <Card
      sx={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        overflow: "hidden",
        borderRadius: { xs: 2, md: 2.5 },
        border: "1px solid #dbe5f0",
        boxShadow: "0 4px 18px rgba(13, 71, 161, 0.10)",
        backgroundColor: "#fff",
      }}
    >
      {/* ================= HEADER ================= */}
      <Box
        sx={{
          background:
            "linear-gradient(135deg, #0D47A1 0%, #1565C0 50%, #1976D2 100%)",
          color: "#fff",
          px: { xs: 1.5, sm: 2, md: 2.5 },
          py: { xs: 1.4, sm: 1.6 },
          minHeight: { xs: 52, sm: 58 },
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "1rem", sm: "1.15rem", md: "1.3rem" },
            fontWeight: 700,
            letterSpacing: "0.2px",
          }}
        >
          Change Your Password
        </Typography>
      </Box>

      <CardContent
        sx={{
          p: { xs: 1.5, sm: 2, md: 2.5 },
          "&:last-child": {
            pb: { xs: 1.5, sm: 2, md: 2.5 },
          },
        }}
      >
        <Toast />

        {/* ================= PASSWORD SECTION ================= */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            boxSizing: "border-box",
            border: "1px solid #dbe5f0",
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              px: { xs: 1.25, sm: 1.75 },
              py: 1,
              background:
                "linear-gradient(135deg, #e3f2fd 0%, #f5f9ff 100%)",
              borderBottom: "1px solid #dbe5f0",
            }}
          >
            <Typography
              sx={{
                color: "#0D47A1",
                fontWeight: 700,
                fontSize: { xs: "0.9rem", sm: "1rem" },
              }}
            >
              Password Information
            </Typography>
          </Box>

          <Box
            sx={{
              p: { xs: 1.5, sm: 2, md: 2.5 },
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(2, minmax(0, 1fr))",
              },
              gap: { xs: 1.5, sm: 2 },
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              boxSizing: "border-box",
            }}
          >
            {/* ================= NEW PASSWORD ================= */}
            <TextField
              fullWidth
              size="small"
              type={showPassword ? "text" : "password"}
              label="New Password"
              variant="outlined"
              value={newPassword}
              onChange={(e) => {
                setNewPassword(e.target.value);

                // Clear mismatch error while typing
                if (errors.confirmPassword) {
                  setErrors((prev) => ({
                    ...prev,
                    confirmPassword: "",
                  }));
                }
              }}
              error={!!errors.newPassword}
              helperText={errors.newPassword}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleClickShowPassword}
                      edge="end"
                      aria-label="toggle password visibility"
                    >
                      {showPassword ? (
                        <VisibilityOff />
                      ) : (
                        <Visibility />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                minWidth: 0,
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "#fff",
                },
                "& .MuiOutlinedInput-root:hover fieldset": {
                  borderColor: "#1976D2",
                },
                "& .MuiOutlinedInput-root.Mui-focused fieldset": {
                  borderColor: "#1565C0",
                },
              }}
            />

            {/* ================= CONFIRM PASSWORD ================= */}
            <TextField
              fullWidth
              size="small"
              type={showPassword ? "text" : "password"}
              label="Confirm New Password"
              variant="outlined"
              value={confirmPassword}
              onChange={(e) => {
                setConfirmPassword(e.target.value);

                if (errors.confirmPassword) {
                  setErrors((prev) => ({
                    ...prev,
                    confirmPassword: "",
                  }));
                }
              }}
              error={!!errors.confirmPassword}
              helperText={errors.confirmPassword}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleClickShowPassword}
                      edge="end"
                      aria-label="toggle password visibility"
                    >
                      {showPassword ? (
                        <VisibilityOff />
                      ) : (
                        <Visibility />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                minWidth: 0,
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "#fff",
                },
                "& .MuiOutlinedInput-root:hover fieldset": {
                  borderColor: "#1976D2",
                },
                "& .MuiOutlinedInput-root.Mui-focused fieldset": {
                  borderColor: "#1565C0",
                },
              }}
            />
          </Box>
        </Box>

        {/* ================= PASSWORD NOTE ================= */}
        <Box
          sx={{
            mt: 1.5,
            px: 1.5,
            py: 1.1,
            borderRadius: 1.5,
            backgroundColor: "#eef6ff",
            border: "1px solid #cfe2ff",
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "0.74rem", sm: "0.8rem" },
              color: "#456",
              lineHeight: 1.5,
            }}
          >
            Enter your new password and confirm it to change your password.
          </Typography>
        </Box>

        {/* ================= ACTION BUTTONS ================= */}
        <Box
          sx={{
            mt: { xs: 1.5, sm: 2 },
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, minmax(0, 1fr))",
            },
            gap: 1.25,
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
          }}
        >
          <button
            className="button button1"
            type="button"
            onClick={handleSubmit}
            title="Click for Change Password"
            style={{
              width: "100%",
              minHeight: "42px",
              border: "none",
              borderRadius: "8px",
              background:
                "linear-gradient(135deg, #0D47A1 0%, #1565C0 100%)",
              color: "#fff",
              fontWeight: 700,
              cursor: "pointer",
              boxShadow: "0 3px 8px rgba(13, 71, 161, 0.22)",
            }}
          >
            Change Password
          </button>

          <button
            className="button button1"
            type="button"
            onClick={handleClose}
            title="Close"
            style={{
              width: "100%",
              minHeight: "42px",
              border: "none",
              borderRadius: "8px",
              background:
                "linear-gradient(135deg, #c62828 0%, #e53935 100%)",
              color: "#fff",
              fontWeight: 700,
              cursor: "pointer",
              boxShadow: "0 3px 8px rgba(198, 40, 40, 0.20)",
            }}
          >
            Close
          </button>
        </Box>
      </CardContent>
    </Card>
  </Box>
);
};

export default ChangePasswordForm;
